import { Plan } from '@/app/(intakeFormV2)/intake-v2/types';
import uniqBy from 'lodash.uniqby';
import { DetailsCard } from '../../common/DetailsCard';

export const MembershipIncludesBlock = ({ plans }: { plans: Plan[] }) => {
  const unique = uniqBy(plans, name => name);

  if (!unique.length) return null;

  if (unique.length == 1)
    return (
      <div className='grid grid-cols-2 gap-4 xl:grid-cols-4'>
        <div className='col-span-2 xl:col-start-2'>
          <DetailsCard plan={unique[0]} />
        </div>
      </div>
    );

  return (
    <div className='grid grid-cols-1 gap-8 xl:grid-cols-2'>
      {unique.includes('Platinum') && <DetailsCard plan='Platinum' />}

      {unique.includes('Signature') && <DetailsCard plan='Signature' />}

      {unique.includes('Pediatrics') && <DetailsCard plan='Pediatrics' />}
    </div>
  );
};
